import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const METRICS_URL = process.env.REACT_APP_METRICS_URL
const CLIENT_ID = process.env.REACT_APP_BASE_DOMAIN
const PLATFORM = 'admin_web'
const VISIT_KEY = 'metrics_visitId'

const isLocalhost =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
const isPrerender = window.location.search.includes('__prerender=1')
const shouldSkip = isLocalhost || isPrerender

const useMetrics = () => {
  const location = useLocation()
  const visitIdRef = useRef<string | null>(sessionStorage.getItem(VISIT_KEY))

  const hashString = async (str: string): Promise<string> => {
    try {
      const msg = new TextEncoder().encode(str)
      const hash = await crypto.subtle.digest('SHA-256', msg)
      return Array.from(new Uint8Array(hash))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('')
    } catch {
      return str
    }
  }

  useEffect(() => {
    if (shouldSkip || visitIdRef.current) return
    ;(async () => {
      try {
        const uaHash = await hashString(navigator.userAgent)
        const res = await fetch(`${METRICS_URL}/visit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            domain: CLIENT_ID,
            platform: PLATFORM,
            userAgentHash: uaHash,
            referrer: document.referrer,
          }),
        })
        const data = await res.json()
        visitIdRef.current = data.id
        sessionStorage.setItem(VISIT_KEY, data.id)
      } catch {}
    })()
  }, [])

  useEffect(() => {
    if (shouldSkip || !visitIdRef.current) return
    fetch(`${METRICS_URL}/hit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        visitId: visitIdRef.current,
        eventType: 'pageview',
        path: location.pathname + location.search,
        domain: CLIENT_ID,
      }),
    }).catch(() => {})
  }, [location])

  return {}
}

export default useMetrics
